<div class="modal-container">
  <div mat-dialog-title
       class="modal-header">
    <h1 class="modal-title">{{data.title}}</h1>
  </div>
  <div mat-dialog-content
       class="modal-content">
    <div class="message-container">
      <input [(ngModel)]="confirmString"
             type="text"
             [placeholder]="data.confirmPlaceholder ?? 'Confirm text'"
             class="datex-textbox" />
      <div class="main-message">{{data.message}}</div>
    </div>
  </div>
  <div mat-dialog-actions
       class="modal-toolbar commands">
    <button mat-button
            [disabled]="!canConfirm"
            class="datex-button primary"
            (click)="onConfirmClicked()">{{data.confirmButton}}</button>
    <button mat-button
            class="datex-button secondary"
            (click)="onCancelClicked()">{{data.cancelButton}}</button>
  </div>
</div>